import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "DashboardsModule"
const debug = false

export class DashboardsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.DASHBOARDS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Dashboards"
        this.description                = "The Dashboard Module offers a centralized and customizable overview of your entire project landscape, enhancing decision-making and productivity. It integrates real-time updates on tasks, projects, and performance metrics, providing users with a comprehensive snapshot of their work progress and team productivity in a single glance. Ideal for streamlining workflows and improving team coordination, this module serves as the essential hub for managing projects efficiently and effectively."
        this.svgIcon                    = "isvg-view-dashboard"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/dashboards"
        this.parentSection              = SettingsParentSection.PRODUCTIVITY

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}